import React from 'react'
import { uid } from 'uid'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import Menu, { MenuProps } from '@material-ui/core/Menu'
import ListItemText from '@material-ui/core/ListItemText'
import { InputType, IInput, IBlock, InputList } from '../types/templates'

/**
 * define styles for the component
*/
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

/**
 * define styles for the component
*/
const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

// Define IBlockInputParamsState interface
interface IBlockInputsParamsState {
  setBlocks: (newState: IBlock[]) => void
  blocks: IBlock[]
  setInputs: (newState: IInput[]) => void
  inputs: IInput[]
}

/**
 * Custon `MenuInputs` component declaration.
 * @param {Function} setInputs
 * @param {IInput} inputs
 * @return MenuInputs
 */
export default function MenuInputs({
  setInputs,
  inputs,
}: // blocks,
// setBlocks,
IBlockInputsParamsState) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const createInput = (type: InputType) => {
    // const newBlocks = blocks.filter((b: IBlock) => b.uid !== block.uid)
    const inputUid = uid()
    // newBlocks.push({ ...block, input: inputUid })
    // setBlocks(newBlocks)
    setInputs([...inputs, { type, uid: inputUid }])
    setAnchorEl(null)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <Button
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="contained"
        color="primary"
        onClick={handleClick}
      >
        Añadir Input
      </Button>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {InputList.map((input, index: number) => (
          <StyledMenuItem key={index} onClick={() => createInput(input.type)}>
            <ListItemText primary={input.name} />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </div>
  )
}